import { GSPAssociationKey } from './GSPAssociationKey';
import { ForeignKeyConstraintType } from './ForeignKeyConstraintType';
import { GSPDeleteRuleType } from './GSPDeleteRuleType';
import { JoinMode } from './JoinMode';
import { GspCommonField } from '../GspCommonField';
import { AssoCondition } from './AssoCondition';
import { AssoModelInfo } from '../../../common-model/src/Element/AssoModelInfo';

/**
 * 关联关系
 * @author wangjiegj<wangjiegj@inspur.com>
 */


/**
 * 关联关系
 */
export class CefGSPAssociation {

    /**
     * 标识
     */
    public ID: string;

    // /**
    //  * 引用的数据模型
    //  */
    // public RefModel: IGSPCommonModel;

    /**
     * 引用的数据模型ID
     */
    public RefModelID: string;

    /**
     * 引用的数据模型包名
     */
    public RefModelPkgName: string;

    /**
     * 引用的数据模型编号
     */
    public RefModelCode: string;

    /**
     * 引用的数据模型名称
     */
    public RefModelName: string;

    /**
     * 引用的节点ID
     */
    public RefObjectID: string;

    /**
     * 引用的节点编号
     */
    public RefObjectCode: string;

    /**
     * 引用的节点名称
     */
    public RefObjectName: string;

    /**
     * 隶属于的元素
     */
    // public BelongElement: IGSPCommonElement;

    /**
     * KeyCollection
     */
    public KeyCollection: GSPAssociationKey[];
    // private _keyCollection: GSPAssociationKey[];
    // get KeyCollection(): GSPAssociationKey[] { if (!this._keyCollection)
    // { this._keyCollection = new Array<GSPAssociationKey>(); } return this._keyCollection; }
    // set KeyCollection(value: GSPAssociationKey[]) { this._keyCollection = value; }

    /**
     * 引用的元素集合
     */
    public RefElementCollection: GspCommonField[];
    // private _refElementCollection: IGSPCommonElement[];
    // get RefElementCollection(): IGSPCommonElement[] { if (!this._refElementCollection)
    //  { this._refElementCollection = new Array<IGSPCommonElement>(); } return this._refElementCollection; }
    // set RefElementCollection(value: IGSPCommonElement[]) { this._refElementCollection = value; }

    /**
     * 过滤条件
     */
    public Where: string;

    /**
     * 提示错误信息
     */
    public AssSendMessage: string;

    /**
     * 外键约束类型
     */
    public ForeignKeyConstraintType: ForeignKeyConstraintType;

    /**
     * 删除规则类型
     */
    public DeleteRuleType: GSPDeleteRuleType;

    /**
     * 联接方式
     */
    public JoinMode: JoinMode;
    /**
     * 关联条件
     */
    public AssoConditions: AssoCondition[];
    /**
     * 表达式JSON中保留文本
     */
    public keepAssoPropertyForExpression: boolean;
    /**
     * 当前关联引用的元数据是生成还是解析型
     */
    public RefModelMode: ProcessMode;
    /**
     * 关联模型信息
     */
    public AssoModelInfo: AssoModelInfo;
    /**
     * 引用的节点的别名
     */
    public RefTableAlias: string;

}

export class ProcessMode {
    static generation = 'generation';
    static interpretation = 'interpretation';  
  }

